import { useMutation, useQuery } from '@tanstack/react-query';

import { useServices } from '@/shared/hooks/use-services';
import { queryClient } from '@/shared/lib/query-client';
import { getToken } from '@/shared/http/client';

export const profileCompletionKey = (slug?: string) => ['profile-completion', slug ?? ''];

/** PRAT-161: estado do perfil do cliente logado (sem login, não consulta). */
export function useProfileCompletion(slug?: string, enabled = true) {
  const { getProfileCompletion } = useServices();

  return useQuery({
    queryKey: profileCompletionKey(slug),
    queryFn: () => getProfileCompletion.execute({ slug }),
    enabled: enabled && !!getToken(),
    staleTime: 60_000,
    retry: false,
  });
}

export function useRequestEmailConfirmation(slug?: string) {
  const { requestEmailConfirmation } = useServices();

  return useMutation({
    mutationFn: (email: string) => requestEmailConfirmation.execute({ email, slug }),
    onSuccess: data => {
      queryClient.setQueryData(profileCompletionKey(slug), data);
    },
  });
}

export function refreshProfileCompletion() {
  return queryClient.invalidateQueries({ queryKey: ['profile-completion'] });
}
